import {Injectable} from "@angular/core";
import * as AspNetData from 'devextreme-aspnet-data-nojquery';
import CustomStore from 'devextreme/data/custom_store';
import {HhsgKeyValuePair} from "../models";
import {OidcSecurityService} from "angular-auth-oidc-client";
import {map} from "rxjs/operators";
import {Observable} from "rxjs";

@Injectable()
export class HhsgSharedAspDataStoreService {
  constructor(
    public oidcSecurityService: OidcSecurityService) {
  }

  public createASPDataStore(options: AspNetData.Options, headerOptions?: HhsgKeyValuePair[]): Observable<CustomStore>  { //Promise<CustomStore> {
    return this.oidcSecurityService.getAccessToken().pipe(map((token) => {
      return this.getCustomStore(options, token, headerOptions);
    }));
  }

  getCustomStore(options: AspNetData.Options, token: string, headerOptions?: HhsgKeyValuePair[]) : CustomStore {
    options.onBeforeSend = (operation, ajaxSettings) => {
      let headers = {};

      headers['Authorization'] = 'Bearer ' + token;

      headerOptions?.forEach(item => {
        headers[item.key] = item.value;
      });

      ajaxSettings.headers = headers;
    }
    return AspNetData.createStore(options);
  }
}
